<template>
  <div class="transaction-info-entry-default">
    <div class="transaction-info-entry-default__label">
      <slot name="label">{{ title }}:</slot>
    </div>
    <div class="transaction-info-entry-default__value">
      <slot name="account">
        <div v-if="instance && account" class="transaction-info-entry-default__account">
          <EditField
            ref="accountRef"
            :instance
            :method="`getFormAccountId${index}`"
            :display="`displayAccountId${index}`"
            @edit="handleEdit"
          />
        </div>
      </slot>
      <slot name="amount">
        <div v-if="instance && amount" class="transaction-info-entry-default__amount">
          <EditField
            ref="amountRef"
            :instance
            :method="`getFormAmount${index}`"
            :display="`displayAmount${index}`"
            @edit="handleEdit"
          />
        </div>
      </slot>
      <slot name="asset">
        <div v-if="instance && asset" class="transaction-info-entry-default__asset">
          <EditField
            ref="assetRef"
            :instance
            :method="`getFormAssetId${index}`"
            :display="`displayAssetId${index}`"
            @edit="handleEdit"
          />
        </div>
      </slot>
    </div>
  </div>
</template>

<script setup lang="ts">
import { TransactionClass } from '@types'

import EditField from './EditField.vue'
import { useTemplateRef } from 'vue'

type Props = {
  instance?: TransactionClass
  index: number
  title?: string
  account: boolean
  amount: boolean
  asset: boolean
}

type Emits = {
  edit: [string]
}

defineProps<Props>()
const emit = defineEmits<Emits>()

defineExpose({
  reset: (field?: string) => {
    accountRef.value?.reset(field)
    amountRef.value?.reset(field)
    assetRef.value?.reset(field)
  },
})

const accountRef = useTemplateRef('accountRef')
const amountRef = useTemplateRef('amountRef')
const assetRef = useTemplateRef('assetRef')

const handleEdit = (field: string) => {
  emit('edit', field)
}
</script>

<style>
.transaction-info-entry-default {
  @apply flex flex-col gap-0.5;

  &__label {
    @apply font-medium;
    @apply text-gray-400;
    @apply uppercase;
  }

  &__value {
    @apply flex flex-wrap gap-1;
  }
}
</style>
